import React, { Component } from "react";
import { Button, Input, Modal, Select, Popover, Spin, Tabs } from "antd";
import CustomLoader from "../../components/loader";
import networkList from "../../constants/networkList";
import postService from "../../services/httpService";
import searchIcon from "../../assets/images/searchicon.svg";
import patientIcon from "../../assets/images/Patient.svg";
import userIcon from "../../assets/images/user_color.svg";
import service from "../../assets/images/service.svg";
import user from "../../assets/images/user.svg";
import gender from "../../assets/images/Gender.svg";
import calender from "../../assets/images/calender.svg";
import userColor from "../../assets/images/user_color.svg";
import token from "../../assets/images/TokenGenerator.svg";
import Patient from "../../assets/images/Patient.svg";
import BillerPatientCard from "./BillerPatientCard";
import moment from "moment";
import * as R from "ramda";
import userTrackService from "../../services/usertrack-service";
import Storage from "../../services/local-store";
import DoctorCard from "../../components/Card/Doctor";
import TabView from "../../components/TabView.js";
import Search from "antd/lib/input/Search";
import IdleTimer from "react-idle-timer";
import { InfoCircleOutlined } from '@ant-design/icons';
import { SyncOutlined } from '@ant-design/icons';
import { CloseOutlined } from '@ant-design/icons';
import {socket} from './../../components/Card/Assign/index.js';
// import {sockets} from './../operator/OperatorView.js'


const $ = require("jquery");
const { Option } = Select;
const { confirm } = Modal;
const antIcon = (
  // <Icon
  //   type="sync"
  //   style={{ fontSize: 48, left: "-19px", bottom: "10px" }}
  //   spin
  // />


<SyncOutlined style={{ fontSize: 48, position: 'relative', left: '-19px', bottom: '10px' }} spin />

);
// for biller and doctor
class Biller extends Component {
  constructor(props) {
    super(props);
    this.state = {
      startBilling: false,
      ifLoading: false,
      searchVal: "",
      filteredTokenListOnSearch: [],
      tokensList: [],
      workstationsList: [],
      workstationSelected: "",
      workstationSelectedDetails: "",
      cabinsList: [],
      roomsList: [],
      cabinSelected: "",
      roomSelected: "",
      //   roomSelectedDetails: "",
      QRoomDetails: "",
      doctorViewPatientsList: [],
      popupclicked: false,
      currentAssignedToken: "",
      modalVisible: false,
      billerskipReason: "",
      visible: false,
      isLoading: false,
      statecheckindelayReason: "",
      statecheckindelayTime: "",
      parentthis: this,
      checkindelaymodalvisible: false,
      ModalText: "Content of the modal",
      ModalError: false,
      confirmLoading: false,
      checkinDelayReasonsforDropdown: [],
      skipmodalvisible: false,
      stateskipReason: "",
      skipReasonsforDropdown: [],
      tatmodalvisible: false,
      TATexceededReason: "",
      TATexceededTime: "",
      getDoctorQueuePatientsMessage: "",
      handleClickChangeID: "",
      billingPatients: [],
      skipPatient: "",
      checkoutModalVisible: false,
      checkoutReason: "",
      queueList: [],
      selectedRoom: "",
      currentPatient: "",
      currentObj: null,
      checkindelaypatient: null,
      totalSearchVal: "",
      totalPatients: [],
      searchTotalPatients : '',
      searchCompletedPatients : [],
      tabContent : [
        { key: 1, text: "Que" ,title: "In-progress", icon_type: "hourglass" },
        { key: 2, text: "Done" ,title: "Completed", icon_type: "check-circle" },
        { key: 3, text: "All" ,title: "Total", icon_type: "database" },
      ],
      lastRefreshedAt: null,
    };
    this.idleTimer = null
    this.onIdle = this._onIdle.bind(this)
    this.onAction = this._onAction.bind(this)
  }
  _onIdle() {
    const { slug } = this.props.match.params;
    // refresh calls
    if (slug === "doctor-view") {
        this.getDoctorQueuePatients("autoRefresh")
    }
  };
  _onAction(e) {
    const {lastRefreshedAt} = this.state;
    let now = moment()
    let last = moment(lastRefreshedAt)
    let diff = now.diff(last, 'seconds')
    if(diff>7){
      if (this.props.match.params.slug === "doctor-view") {
        this.getDoctorQueuePatients("autoRefresh")
      }
    }
    // console.log('REFRESH last',last)
    // console.log('REFRESH diff',diff)
  }
  onSkipforBiller() {
    this.setModalVisible(true);
    this.setState({ stateskipReason: "" });
  }
  componentDidMount() {
    // this.initializeWebSocket();
    const { slug } = this.props.match.params;
    const { getWorkStationsForDoctorORBillers } = networkList;
    if (slug === "biller-view") {
      this.getSkipReasonsforDropdown();

      postService(getWorkStationsForDoctorORBillers, "GET", null).then(
        (res) => {
          // console.log("getWorkStationsForDoctorORBillers", res.data);
          if (res.status) {
            this.setState({ workstationsList: res.data });
          }
        }
      );
    }
    if (slug === "doctor-view") {
      this.getDelayReasonsforDropdown();
      this.getDoctorQueuePatients();
      this.getSkipReasonsforDropdown();

      this.interval = setInterval(
        this.getDoctorQueuePatients.bind(this, "autoRefresh"),
        20000
      );
    }
  }
  // initializeWebSocket(){
  //   sockets.onopen = () => {
  //     console.log('WebSocket connection established HIS.');
  //    };
  //   sockets.onmessage = (event) => {
  //         const message = event.data;
  //         // let obj=JSON.parse(message);
  //         console.log(`Received message from server HIS: ${message}`);
  //         this.getDoctorQueuePatients();
  //       }
  //      sockets.onclose = () => {
  //       console.log('WebSocket connection closed HIS.');
      
  //     };
  //      sockets.onerror = (error) => {
  //       console.error('WebSocket error HIS:', error);
  //      }; 

  //   socket.onopen = () => {
  //     console.log('WebSocket connection established.');
  //     // this.onStartQ(queueitem, "withoutassign")
  //     // socket.send("message sent to server");
  //  };
  //  socket.onmessage = (event) => {
    
  // // const Queuerefresh=new QueuepatientDetailshell({item:this.state.item});
  // // const Operatorview=new OperatorView();
  //     const message = event.data;
  //     let obj=JSON.parse(message);
  //     console.log(`Received message to biller : ${message}`);
  //     if(message==='{"data":"doctorbreak"}'){
  //       console.log("doctorbreak");
  //       console.log(message);
  //       this.getDoctorQueuePatients();
  //     }
  //     else {
  //       console.log("checkin-------------in biller ",obj);

  //       this.refreshSingleQueue(obj.data, obj.action);
  //     }
     
     
  
  //     // Operatorview.deActivateLoader();
  //     // Operatorview.setlastRefreshedAt(moment());
  //  }
  //   //  this.onStartQUseWebsocket(message);
  //    // Handle incoming messages from the server as needed.
  // //  };
  // socket.onclose = () => {
  //     console.log('WebSocket connection closed.');
    
  //   };
  //    socket.onerror = (error) => {
  //     console.error('WebSocket error:', error);
  //    };
  //    }
  componentDidUpdate(prevProps, prevState) {
    $(".custom-container").css({
      height:
        $(window).outerHeight() -
        ($("header").outerHeight() + $(".breadCrums").outerHeight()),
      "padding-bottom": "0px",
    });
    // $(".b-card").css({
    //   height: $(".custom-container").outerHeight() - 30,
    // });
    // $(".h-card1").css({
    //   height: $(".custom-container").outerHeight() - 30,
    // });
    // $(".b-card").css({
    //   height:
    //     $(".custom-container").outerHeight() - $(".h-card").outerHeight() - 20,
    // });
    // $(".b-card1").css({
    //   height:
    //     $(".custom-container").outerHeight() - $(".h-card").outerHeight() + 30,
    // });
    $(".b-card").css({
      height:
        $(".custom-container").outerHeight() - $(".h-card1").outerHeight() - 25,
    });
    $(".b-card1").css({
      height:
        $(".custom-container").outerHeight() - $(".h-card1").outerHeight() + 35,
    });
    $(".b-card2").css({
      height:
        $(".custom-container").outerHeight() - $(".h-card1").outerHeight(),
    });
    $(".b-card-scroll").css({
      height: $(".b-card").outerHeight() - 13,
    });
    if (prevState.selectedRoom !== this.state.selectedRoom) {
      // let roomDetails = this.state.roomsList.filter(
      //   (room) => room.room_number === this.state.selectedRoom
      // );
      // this.setState({ QRoomDetails: roomDetails[0] });

      // this.setState({ QRoomDetails: this.state.selectedRoom });
      this.getDoctorQueuePatients();
    }
  }
  renderTime(date) {
    return moment(date).format("hh:mm A");
  }
  getDoctorQueuePatients(type) {
    // postService("getDoctorQueuePatients", "POST", {
    //   data: {
    //     queue_list_id: this.state.QRoomDetails["queue_list_id"],
    //   },
    // })
    type === "manualRefresh" &&
      this.setState({
        ifLoading: true,
      });
    postService("getDoctorQueuePatients", "GET", null)
      .then((res) => {
        if (res.status) {
          let getcurrentroomdetails =
            this.state.selectedRoom &&
            res.data &&
            res.data.filter(
              (q) =>
                q.queuelistid ===
                (this.state.selectedRoom && this.state.selectedRoom.queuelistid)
            );
          let currentroomdetails = getcurrentroomdetails
            ? getcurrentroomdetails[0]
            : res.data && res.data[0];
          this.setState({
            QRoomDetails: currentroomdetails,
            ifLoading: false,
          });
          if (res.data.length) {
            let sortByDisplayOrder = res.data.sort(function(a, b) {
              return (a.display_order===null)-(b.display_order===null) || +(a.display_order>b.display_order)||-(a.display_order<b.display_order);
            });
            let list = currentroomdetails && currentroomdetails.patients;
            let totalPatients = currentroomdetails && currentroomdetails.totalPatients;
            let completedPatients = currentroomdetails && currentroomdetails.completedPatients;
            this.setState({
              queueList: sortByDisplayOrder,
              doctorViewPatientsList: list,
              totalPatients: totalPatients,
              completedPatients: completedPatients,
              // billingPatients: list,
              ifLoading: false,
              lastRefreshedAt: moment(),
            });
          } else {
            res.message &&
              this.setState({
                ifLoading: false,
                getDoctorQueuePatientsMessage: res.message,
              });
          }
        }
      })
      .catch((err) => {
        this.setState({ ifLoading: false });
      });
  }
  selectWorkstation(event) {
    const { slug } = this.props.match.params;
    this.setState({ workstationSelected: event });
    let selectedWSDetails = this.state.workstationsList.filter(
      (station) => station.work_station_name === event
    );
    this.setState({ workstationSelectedDetails: selectedWSDetails });

    if (slug === "biller-view") {
      postService("getMasterCabins", "POST", {
        data: {
          unit_id: selectedWSDetails[0]["unit_id"],
          work_station_id: selectedWSDetails[0]["id"],
          type: slug === "biller-view" ? "biller" : "doctor",
        },
      }).then((res) => {
        if (res.status) {
          this.setState({ cabinsList: res.data });
        }
      });
    }
    if (slug === "doctor-view") {
      postService("getOPDRoomsByLocation", "POST", {
        data: {
          unitid: selectedWSDetails[0]["unit_id"],
          work_station_id: selectedWSDetails[0]["id"],
        },
      }).then((res) => {
        if (res.status) {
          this.setState({ roomsList: res.data });
        }
      });
    }
  }
  selectCabin(value) {
    const { slug } = this.props.match.params
    if (slug === "biller-view") {
      this.setState({ cabinSelected: value });
    }
    if (slug === "doctor-view") {
      this.setState({ roomSelected: value });
    }
  }

  onStartBilling() {
    this.setState({ startBilling: true });
    this.getTokenList();
    this.assignTokenToBiller();
  }
  getTokenList() {
    const { BillerTokenList } = networkList;
    const { slug } = this.props.match.params;
    this.setState({ ifLoading: true });
    if (slug === "biller-view") {
      postService(BillerTokenList, "POST", {
        data: {
          unitid: this.state.workstationSelectedDetails[0]["unit_id"],
          work_station_id: this.state.workstationSelectedDetails[0]["id"],
        },
      })
        .then((res) => {
          if (res.status) {
            this.setState({ tokensList: res.data, ifLoading: false });
          }
        })
        .catch((err) => {
          this.setState({ ifLoading: false });
        });
    }
  }
  assignTokenToBiller() {
    const { AssignTokenToBiller } = networkList;
    const { slug } = this.props.match.params;

    if (slug === "biller-view") {
      postService(AssignTokenToBiller, "POST", {
        data: {
          unitid: this.state.workstationSelectedDetails[0]["unit_id"],
          work_station_id: this.state.workstationSelectedDetails[0]["id"],
        },
      })
        .then((res) => {
          if (res.status) {
            this.setState({ currentAssignedToken: res.data });
          }else {
            Modal.error({
              title: "Error!",
              content: "Something went wrong.",
            })
          }
        })
        .catch((err) => console.log("AssignTokenToBiller err", err));
    }
  }
  billerWelcomeScreen() {
    const { slug } = this.props.match.params;
    let {
      workstationsList,
      workstationSelected,
      cabinsList,
      cabinSelected,
      roomsList,
      roomSelected,
    } = this.state;
    return (
      <div className="col StartTG">
        <h5>Welcome!</h5>
        {/* <h6>Patients are waiting in the queue.</h6> */}
        <h6>Click to start Queue.</h6>
        <Select
          id="location"
          placeholder="Select Location"
          style={{ width: 240 }}
          onChange={this.selectWorkstation.bind(this)}
        >
          {workstationsList.map((station) => (
            <Option value={station.work_station_name} key={station.id}>
              {station.work_station_name}
            </Option>
          ))}
        </Select>
        {workstationSelected && (
          <Select
            id={slug === "biller-view" ? "counter" : "room"}
            placeholder={`Select ${
              slug === "biller-view" ? "Counter" : "Room"
            }`}
            className="my-4"
            style={{ width: 240 }}
            onChange={this.selectCabin.bind(this)}
          >
            {slug === "biller-view" &&
              cabinsList.map((cabin) => (
                <Option value={cabin.cabin_name} key={cabin.id}>
                  {cabin.cabin_name}
                </Option>
              ))}
            {slug === "doctor-view" &&
              roomsList.map((room) => (
                <Option value={room.room_number} key={room.queue_list_id}>
                  {room.room_number}
                </Option>
              ))}
          </Select>
        )}
        {(cabinSelected || roomSelected) && (
          <Button
            className="TGStartBtn btn-magenta"
            size="large"
            onClick={this.onStartBilling.bind(this)}
          >
            Start Queue!
          </Button>
        )}
      </div>
    );
  }
  getSearchResults(value, type) {
    const { slug } = this.props.match.params;
    this.setState({ searchVal: value });

    if (slug === "biller-view") {
      // this.setState({ searchVal: value });

      let filteredTokenList = this.state.tokensList.filter(
        (item) =>
          (item.patient_name &&
            item.patient_name.toLowerCase().includes(value.toLowerCase())) ||
          (item.phone_number && item.phone_number.includes(value))
      );
      this.setState({ filteredTokenListOnSearch: filteredTokenList });
    }
    if (slug === "doctor-view") {
      this.getPatientSearchResults(value, type);
    }
  }

  getPatientSearchResults(value, type) {
    let actualPatients = [];
    if(type === 'in-progress'){
      actualPatients = (this.state.doctorViewPatientsList &&
        this.state.doctorViewPatientsList.length
          ? this.state.doctorViewPatientsList
          : "") || [];
    }
    else if(type === 'completed'){
      actualPatients = (this.state.completedPatients &&
        this.state.completedPatients.length
          ? this.state.completedPatients
          : "") || [];
    }
    else{
      actualPatients = (this.state.totalPatients &&
        this.state.totalPatients.length
          ? this.state.totalPatients
          : "") || [];
    }
    if (value) {
      let searchKey = value;
      let searchresults = actualPatients.filter((s) => {
        if (
          R.includes(R.toLower(searchKey), R.toLower(s.name ? s.name : "null"))
        ) {
          return s;
        } else if (
          R.includes(R.toLower(searchKey), R.toLower(s.umr ? s.umr : "null"))
        ) {
          return s;
        } else if (
          R.includes(
            R.toLower(searchKey),
            R.toLower(s.patienttype ? s.patienttype : "null")
          )
        ) {
          return s;
        }
      });
      if(type === 'in-progress'){
        this.setState({ billingPatients: searchresults });
      }
      else if(type === 'completed'){
        this.setState({ searchCompletedPatients: searchresults });
      }
      else{
        this.setState({ searchTotalPatients: searchresults });
      }
      // this.setState({ billingPatients: searchresults });
    } 
    else {
      if(type === 'in-progress'){
        this.setState({ billingPatients: actualPatients });
      }
      else if(type === 'completed'){
        this.setState({ searchCompletedPatients: actualPatients });
      }
      else{
        this.setState({ searchTotalPatients: actualPatients });
      }
      // this.setState({ billingPatients: actualPatients });
    }
  }
  hide = () => {
    this.setState({ popupclicked: false });
  };
  handleCancel = () => {
    this.setState({
      visible: false,
    });
  };
  handleClickChange = (id, visible) => {
    this.setState({ handleClickChangeID: id, popupclicked: visible });
  };
  delayhandleOk = () => {
    this.setState({
      confirmLoading: false,
      checkindelaymodalvisible: false,
    });
  };
  delayhandleCancel = () => {
    this.setState({
      checkindelaymodalvisible: false,
    });
  };
  getDelayReason(value) {
    this.setState({ statecheckindelayReason: value });
  }
  skiphandleOk = () => {
    this.setState({
      confirmLoading: false,
      skipmodalvisible: false,
    });
  };
  checkoutHandleOk = () => {
    this.setState({
      confirmLoading: false,
      checkoutModalVisible: false,
    });
  };
  skiphandleCancel = () => {
    this.setState({
      skipmodalvisible: false,
    });
  };
  checkoutHandleCancel = () => {
    this.setState({
      checkoutModalVisible: false,
    });
  };
  getCheckoutReason(value) {
    this.setState({ checkoutReason: value });
  }
  getSkipReason(value) {
    this.setState({ stateskipReason: value });
  }
  getSkipReasonsforDropdown() {
    postService("getSkipReasons", "GET", "").then((res) => {
      if (res.status) {
        this.setState({ skipReasonsforDropdown: res.data });
      }
    });
  }
  serviceCallForSkip(item) {
    if (this.state.stateskipReason != "") {
      this.setState({ skipmodalvisible: false });
      let currentObj = this.state.skipPatient;
      let currentQ = this.state.QRoomDetails || [];
      //   QueueList = QueueList.filter((s) => s.display_status != "1");
      //   QueueList.forEach((skipitem1) => {
      //   if (skipitem1.roomnumber === this.props.queueitem.roomnumber) {

      let obj = {
        patientId: currentObj.id,
        queueListId: currentQ.queuelistid,
        skip_reason_id: this.state.stateskipReason,
        current_workflow_stage_id: currentObj.current_workflow_stage_id,
        "skip":"3"
      };
      this.activateLoader();
      let Userlogobj = {
        user: JSON.parse(Storage.get("user")),
        action: "skip patient from queue",
        date: new Date(),
        meta: obj,
      };
      userTrackService(Userlogobj);
      postService("skipPatient", "POST", { data: obj }).then((res) => {
        let Userlogobjres = {
          user: JSON.parse(Storage.get("user")),
          action: "skip patient from queue - response",
          date: new Date(),
          meta: res,
        };
        userTrackService(Userlogobjres);
        if (res) {
          //   this.deActivateLoader();

          if (currentObj.current_workflow_stage_id == "3") {
            this.refreshSingleQueue(obj, "skip");
          } else {
            this.refreshSingleQueue(obj, "checkinskip");
          }

          
        }
      });
      //   }
      //   });
      this.hide();
    } else {
      this.setState({ ModalError: true });
    }
  }
  checkinCallWithDelay() {
    const {checkindelaypatient, statecheckindelayReason, QRoomDetails} = this.state
    if (statecheckindelayReason != "" && checkindelaypatient) {
      // let currentObj = item;
      let currentObj = checkindelaypatient;
      let currentQ = QRoomDetails || [];
   
      let checkWorkflowStageobj = R.find(
        R.propEq("current_workflow_stage_id", "4"),
        currentQ.patients
      );

      let obj = {
        patientId: currentObj.id,
        queueListId: currentQ.queuelistid,
        doctor_id: currentQ.queue_doctor_id,
        delay_reason_id: this.state.statecheckindelayReason,
        delay_time: this.state.statecheckindelayTime,
        queue_delay: null,
      };
      if (this.state.statecheckindelayTime > 0) {
        var cdt_time = new Date();
       let service_time=service_time
        var s = moment(cdt_time, "hh:mm A")
          .add(parseInt(service_time), "m")
          .format("hh:mm A");
        obj.queue_delay = s;
      }
      if (!R.isNil(checkWorkflowStageobj)) {
        this.setState({
          ModalText: "You can not Check-In two patients at a time.",
        });
        this.showModal();
      } else {
        this.serviceCallForCheckIn(obj);
      }
      //   }
      //   });
    } else {
      this.setState({ ModalError: true });
    }
  }
  patientCard(list, item, itemindex) {
    const {
      checkindelaymodalvisible,
      confirmLoading,
      ModalText,
      ModalError,
      statecheckindelayReason,
      visible,
      tatmodalvisible,
    } = this.state;
    this.state.currentObj = item;

    const patient_details = item && (
      <div>
        <p className="mb-0">
          Service : {item.service_name ? item.service_name : "--"}
        </p>
        <p className="mb-0">
          Mobile No : {item.phonenumber ? item.phonenumber : "--"}
        </p>
        <p className="mb-0">
          Vitals Required :{" "}
          {item.is_vitals_require !== null ? item.is_vitals_require : "--"}
        </p>
        <p className="mb-0">
          Vitals Status :{" "}
          {item.is_vitals_require === "YES"
            ? item.is_vitals_done !== null
              ? item.is_vitals_done === "YES"
                ? "Done"
                : "Not yet done"
              : "Patient in Vitals Queue"
            : "--"}
        </p>
      </div>
    );
    const popupContent = (
      <div className="popup">
        <h4>
          More Options 
          <img
            onClick={this.hide}
            src="/assets/images/icons/popup-close.png"
            alt="closeicon"
          />
        </h4>
        <div className="row">
          <div className="col">
            <Button
              className="btn-magenta mx-0"
              // onClick={this.onSkip.bind(this)}
              onClick={this.skipPatientFromQueue.bind(this, item)}
            >
              Skip
            </Button>
          </div>
        </div>
      </div>
    );
    return (
      <div
        class={`pl-2 pr-1 ${
          item.is_investigation ? "pb-1" : "py-1"
        } my-2 mr-1 b-card-body disable-text`}
      >
        {/* {item.is_investigation && (
          <small className="text-danger ml-1">Investigation</small>
        )} */}
        <div className="row">
          <p className="text-p-light col-7 pl-1">
            <img alt="" src={patientIcon} class="patientIcon" />
            {item.name}
          </p>
          <div class="col-5 text-right">
            <span class="time m-auto">
              {"WT: "}
              {item.waitingTAT}
            </span>
          </div>
        </div>
        <div className="row">
          <p className="text-p-light col-8 my-auto">
            <Popover
              overlayClassName="popover-custom"
              content={patient_details}
              title=""
            >
              {/* <Icon
                type="info-circle"
                style={{
                  color: "#ac7ab0",
                  transform: "rotate(0deg)",
                  fontSize: "15px",
                  margin: "0 6px 0 -2px",
                }}
              /> */}
             

<InfoCircleOutlined
  style={{
    color: '#ac7ab0',
    transform: 'rotate(0deg)',
    fontSize: '15px',
    margin: '0 6px 0 -2px',
  }}
/>
            </Popover>
            <span>{item.umr ? item.umr : "--"}</span>
          </p>
          <div class="col-4">
            <div
              className="status m-0 mr-1"
              style={{ float: "right", width: "fit-content" }}
            >
              {item && item.status === "3" ? (
                <button
                  // className="btn-magenta w-100 pt-1"
                  className={
                    item.bill_cancel_status == "YES"
                      ? "text-cancelled-disable"
                      : "btn-magenta w-100 p-1"
                  }
                  onClick={this.changePatientStatustoCheckin.bind(
                    this,
                    "checkin",
                    item
                  )}
                  disabled={
                    (item.bill_cancel_status == "YES" ||
                      (item.is_vitals_require === "YES" &&
                        item.is_vitals_done !== "YES")) &&
                    true
                  }
                >
                  {item.bill_cancel_status == "YES"
                    ? "BIL-CAN"
                    : item.is_vitals_require === "YES"
                    ? item.is_vitals_done === "YES"
                      ? "C-IN"
                      : "VITALS"
                    : "C-IN"}
                </button>
              ) : (
                item &&
                item.status === "4" && (
                  <button
                    className="btn-red w-100 p-1"
                    // onClick={this.changePatientStatustoCheckout.bind(
                    //   this,
                    //   "checkout",
                    //   item
                    // )}
                    onClick={this.onDoctorCheckout.bind(this, item)}
                  >
                    C-OUT
                  </button>
                )
              )}
            </div>
          </div>
        </div>

        <div className="row">
          <div className={item.appointment_date !== null ? "col-4" : "col-10"}>
            <span className="Patientname ml-0">
              {/* {item.arrivaltime ? item.arrivaltime : "--"}{" "} */}
              Arr:{" "}
              {this.renderTime(item.arrivaltime) !== "Invalid date"
                ? this.renderTime(item.arrivaltime)
                : "HH:MM"}
            </span>
          </div>
          {item.appointment_date && (
            <div className="col-5">
              <span className="Patientname ml-0">
                {/* {item.arrivaltime ? item.arrivaltime : "--"}{" "} */}
                Apt:{" "}
                {this.renderTime(item.appointment_date) !== "Invalid date"
                  ? this.renderTime(item.appointment_date)
                  : "HH:MM"}
              </span>
            </div>
          )}

          <div className="col-2 my-auto">
            <p className="text-right text-p-bold">
              {/* asd5 */}
              {(list.length - 1 !== itemindex || list.length === 1) && (
                <Popover
                  placement="bottomLeft"
                  content={popupContent}
                  trigger="click"
                  visible={
                    item.id === this.state.handleClickChangeID
                      ? this.state.popupclicked
                      : false
                  }
                  onVisibleChange={this.handleClickChange.bind(this, item.id)}
                >
                  <img
                    src="/assets/images/icons/more-icon.png"
                    alt="more"
                    srcset=""
                    className=""
                  />
                </Popover>
              )}
            </p>
          </div>
        </div>
        <div>
          {/* <Modal
            visible={visible}
            onOk={this.handleOk}
            confirmLoading={confirmLoading}
            onCancel={this.handleCancel}
            footer={null}
          >
            <p>{ModalText}</p>
          </Modal> */}
        </div>
      </div>
    );
  }

  onTabClick = (tab_key) => {
    // console.log('tab_key', tab_key)
    
    if(tab_key === 1){
      // this.setState({billingPatients: []});
      this.setState({searchTotalPatients: []});
    }
    else if(tab_key === 2){
      this.setState({billingPatients: []});
      this.setState({searchTotalPatients: []});
    }
    else{
      this.setState({billingPatients: []});
      this.setState({searchTotalPatients: []});
    }
  };

  // refreshData() {
  //   manualRefresh
  //   this.getDoctorQueuePatients("refresh");
  // }
  queueCol(list) {
    const { slug } = this.props.match.params;
    let that = this;
    const {
      checkindelaymodalvisible,
      confirmLoading,
      ModalText,
      ModalError,
      statecheckindelayReason,
      skipmodalvisible,
      stateskipReason,
      visible,
      tatmodalvisible,
      searchVal,
      selectedRoom,
      QRoomDetails,
      currentObj,
      completedPatients,
      totalPatients,
      handleClickChangeID, 
      popupclicked,
      searchTotalPatients,
      searchCompletedPatients,
      tabContent
    } = this.state;
    const currentRoom = selectedRoom ? selectedRoom : QRoomDetails;
    // let tabContent = [
    //   { key: 1, title: "In-progress", icon_type: "hourglass" },
    //   { key: 2, title: "Completed", icon_type: "check-circle" },
    //   { key: 3, title: "Total", icon_type: "database" },
    // ];

    let displayTotalPatients = searchTotalPatients.length ? searchTotalPatients : totalPatients;
    let displayCompletedPatients = searchCompletedPatients.length ? searchCompletedPatients : completedPatients;
    
    let item = currentObj && currentObj;

    return (
    
      <div className="col-3 col-md-5 col-lg-3">
          {/* <style>
      {`
        .ant-tabs-nav .ant-tabs-tab {
          margin-right: 2px;
          padding: 8px 13px !important;
        }
       
element.style {
}
*, body {
    outline: none;
}
*, html, body {
    margin: 0;
    padding: 0;
    font-family: "Avenir LT Std", sans-serif !important;
    -webkit-font-smoothing: antialiased;
}

:where(.css-dev-only-do-not-override-1okl62o).ant-tabs .ant-tabs-tab-btn:focus:not(:focus-visible), :where(.css-dev-only-do-not-override-1okl62o).ant-tabs .ant-tabs-tab-remove:focus:not(:focus-visible), :where(.css-dev-only-do-not-override-1okl62o).ant-tabs .ant-tabs-tab-btn:active, :where(.css-dev-only-do-not-override-1okl62o).ant-tabs .ant-tabs-tab-remove:active {
    color: white;
}
      `}
    </style> */}
        {slug === "doctor-view" && (
          // <div className="card h-card text-center pt-2">
          //   {this.state.QRoomDetails && (
          //     <span className="m-1">{`Room: ${this.state.QRoomDetails.roomnumber}`}</span>
          //   )}
          // </div>
          <div className="h-card1">
            <DoctorCard
              props={this.state}
              {...this.props}
              item={currentRoom}
              queueDoctors=""
              refreshData={this.getDoctorQueuePatients.bind(this)}
            />
          </div>
        )}
        <div className="card b-card pr-1">
          <div className="row pr-1 d-none">
            <div className="col-8">
              <span class="PatientsTitle">{`Patients (${list.length})`}</span>
            </div>
            <div className="col-4">
              <div className="row mb-1">
                <Popover
                  overlayClassName="popover-custom"
                  placement="top"
                  title={""}
                  content={"Refresh"}
                >
                  <figure
                    className="col py-1 mb-0 text-left"
                    // onClick={this.refreshSingleQueue.bind(
                    //   this,
                    //   this.state.QRoomDetails,
                    //   "refresh"
                    // )}
                    onClick={this.getDoctorQueuePatients.bind(
                      this,
                      "manualRefresh"
                    )}
                  >
                    <img src="/assets/images/icons/refresh.png" alt="refresh" />
                  </figure>
                </Popover>
                <Popover
                  overlayClassName="popover-custom"
                  placement="topRight"
                  title={""}
                  content={"Reset Queue"}
                >
                  <figure
                    className="col py-1 mb-0 px-1 text-center"
                    onClick={this.checkReBuildQ.bind(
                      this,
                      this.state.QRoomDetails,
                      that
                    )}
                    // onClick={this.refreshData.bind(this)}
                  >
                    <img
                      src="/assets/images/icons/re_build.png"
                      alt="rebuild"
                    />
                  </figure>
                </Popover>
              </div>
            </div>
          </div>
          <div className="row mb-3 pr-2 d-none">
            <div className="col-10">
              <Search
                placeholder="Search here"
                value={this.state.searchVal}
                allowClear={true}
                onChange={(e) => this.getSearchResults(e.target.value)}
              />
              {/* <Input
                placeholder="Search here"
                value={this.state.searchVal}
                allowClear={true}
                onChange={(e) => this.getSearchResults(e.target.value)}
              /> */}
            </div>
            <div className="col-2">
              <img
                src={searchIcon}
                alt=""
                className="biller-search-icon-img operatorSearchicon"
              />
            </div>
          </div>
          <div className="b-card-scroll mb-3">
            {slug === "biller-view" &&
              list.map((tokenlistItem) => (
                <BillerPatientCard item={tokenlistItem} />
              ))}
            {
              slug === "doctor-view" && (
                <TabView
                refreshData={this.getDoctorQueuePatients.bind(this)}
                  list={list}
                  QRoomDetails={this.state.QRoomDetails}
                  completedPatients={displayCompletedPatients}
                  totalPatients={displayTotalPatients}
                  slug={slug}
                  tabContent={tabContent}
                  item={item}
                  getSearchResults={this.getSearchResults.bind(this)}
                  getDoctorQueuePatients={this.getDoctorQueuePatients.bind(
                    this,
                    "manualRefresh"
                  )}
                  changePatientStatustoCheckin={this.changePatientStatustoCheckin.bind(this)}
                  onDoctorCheckout={this.onDoctorCheckout.bind(this)}
                  handleClickChange={this.handleClickChange.bind(this)}
                  searchVal={this.state.searchVal}
                  completedSearchVal={this.state.completedSearchVal}
                  totalSearchVal={this.state.totalSearchVal}
                  handleClickChangeID={handleClickChangeID}
                  popupclicked={popupclicked}
                  skipPatientFromQueue={this.skipPatientFromQueue.bind(this)}
                  hide={this.hide}
                  renderTime={this.renderTime()}
                  onTabClick = {this.onTabClick}
                />
              )
              // list.map((patientlistItem, index) => {
              //   return this.patientCard(list, patientlistItem, index);
              // })
            }
          </div>
        </div>
      </div>
    );
  }
  assignNextTokenToBiller() {
    const { AssignNextTokenToBiller } = networkList;
    const { slug } = this.props.match.params;
    if (slug === "biller-view") {
      postService(AssignNextTokenToBiller, "POST", {
        data: {
          unitid: this.state.workstationSelectedDetails["unit_id"],
          work_station_id: this.state.workstationSelectedDetails["id"],
        },
      }).then((res) => {
        // console.log("AssignNextTokenToBiller res", res);
        if (res.status) {
          this.setState({ currentAssignedToken: res.data });
        } else {
          this.setState({ currentAssignedToken: "" });
          Modal.error({
            title: "Notice!",
            content: "There are no Patients in the queue!",
            onOk: function () {
              window.scrollTo(0, 0);
            },
          });
        }
      });
    }
  }
  onCheckout() {
    const { BillerCheckOutPatient } = networkList;
    const { currentAssignedToken } = this.state;
    const { slug } = this.props.match.params;

    if (slug === "biller-view") {
      postService(BillerCheckOutPatient, "POST", {
        data: { id: currentAssignedToken.id },
      }).then((res) => {
        // console.log("BillerCheckOutPatient res", res);
        if (res.status) {
          this.assignNextTokenToBiller();
          this.getTokenList();
        } else {
          Modal.error({
            title: "Notice!",
            content: "There are no Patients in the queue!",
            onOk: function () {
              window.scrollTo(0, 0);
            },
          });
        }
      });
    }
  }

  skipPatientFromQueue(patient) {
    // console.log("skipPatientFromQueue patient", patient);

    this.setState({
      skipPatient: patient,
      ModalText: "Choose the reason for skip",
    });
    this.hide();
    this.showSkipModal();
  }

  showSkipModal = () => {
    this.setState({
      skipmodalvisible: true,
      stateskipReason: "",
      ModalError: false,
    });
  };
  setModalVisible(modalVisible) {
    this.setState((state) => ({
      modalVisible: modalVisible,
    }));
  }
  selectReason(value) {
    // console.log("billerskipReason", value);
    this.setState({ billerskipReason: value });
  }
  onSkipReason(id) {
    postService("skipPatientfromQueue", "POST", {
      data: {
        id: id,
        skip_reason_id: this.state.billerskipReason,
        
      },
    }).then((res) => {
      this.setState({ modalVisible: false });
      if (res.status) {
        this.assignNextTokenToBiller();
        this.getTokenList();
      }
    });
  }
  billerCurrPatientDetailsCol(list) {
    let { currentAssignedToken } = this.state;

    // console.log("billerCurrPatientDetailsCol list", list);
    return (
      <div className="col-9 col-md-7 col-lg-9">
        <div className="card b-card p-2 px-3">
          {list.length ? (
            <>
              <span class="row Token-Generation">Current Patient Details</span>
              <div className="row">
                <div className="col-5">
                  <div className="billerPatientDetails">
                    <div className="row pl-3 mb-2">
                      <div class="patientNameIcon">
                        <img
                          src={user}
                          alt=""
                          className="patientNameIconImage"
                        />
                      </div>
                      <span className="col patientNamedetails">
                        <span className="row text-style-1">Name</span>
                        <span className="row">
                          {currentAssignedToken.patient_name}
                        </span>
                      </span>
                    </div>
                    <div className="row pl-3 mb-2">
                      <div className="patientGenderIcon">
                        <img
                          src={gender}
                          alt=""
                          className="patientGenderIconImage"
                        />
                      </div>
                      <span className="patientGender">
                        Gender
                        <span className="row pl-3 text-style-1">
                          {currentAssignedToken.gender}
                        </span>
                      </span>
                    </div>
                    <div className="row pl-3">
                      <div className="patientageIcon">
                        <img
                          src={calender}
                          alt=""
                          className="patientageIconImage"
                        />
                      </div>
                      <span className="patientAge">
                        <span className="row pl-3 text-style-1">Age</span>
                        {/* 27 Yrs, 3 Months, 20 Days */}
                        {currentAssignedToken.age}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="col-7">
                  <div className="row uidcard">
                    <img src={userColor} alt="" className="uidcardIcon" />
                    <div className="LineCopy">
                      <span className="row UID-no">
                        <span className="text-style-1">UID</span>
                        {/* {currentToken.umr} */}
                        {currentAssignedToken.phone_number}
                      </span>
                    </div>
                  </div>
                  <div className="row tokenCard">
                    <img src={token} alt="" className="tokenCardIcon" />
                    <div className="LineCopy">
                      <span className="row Token-No">
                        Token No
                        <span className="text-style-1">
                          {currentAssignedToken.token_display_id}
                        </span>
                      </span>
                    </div>
                  </div>
                  <div className="row serviceCard">
                    <img src={service} alt="" className="serviceCardimg" />
                    <div className="LineCopy">
                      <span className="row Service-Name-Billing">
                        Service Name
                        <span className="text-style-1">
                          {" "}
                          {currentAssignedToken.service_name}
                        </span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <Button
                  className="Chekoutandnext"
                  onClick={this.onCheckout.bind(this)}
                >
                  <span className="">CheckOut & Next</span>
                </Button>
                <Button
                  className="Skipandnext"
                  onClick={this.onSkipforBiller.bind(this)}
                >
                  <span className="">Skip & Next</span>
                </Button>
              </div>

              <Modal
                centered
                footer={null}
                maskClosable={false}
                visible={this.state.modalVisible}
                onOk={() => this.setModalVisible(false)}
                onCancel={() => this.setModalVisible(false)}
              >
                <div className="row">
                  <button
                    type="button"
                    class="btn"
                    onClick={() => this.setModalVisible(false)}
                  >
                    {/* <Icon type="close" className="popup-close" /> */}
                  

<CloseOutlined className="popup-close" />

                  </button>
                  <div className="col-12 position-relative form-block py-4">
                    <form noValidate>
                      <div className="row mb-4">
                        <div className="col-12 mx-auto">
                          <h2 className="text-center">Choose reason to skip</h2>
                        </div>
                      </div>
                      <div className="row mb-5">
                        <div className="col-8 w-100 mx-auto">
                          <Select
                            placeholder="Select the reason"
                            onChange={this.selectReason.bind(this)}
                          >
                            <Option value="">Select the Reason</Option>
                            {this.state.skipReasonsforDropdown &&
                              this.state.skipReasonsforDropdown.map((d, i) => {
                                return (
                                  <Option value={d.id} key={i}>
                                    {d.reason}
                                  </Option>
                                );
                              })}
                          </Select>
                        </div>
                      </div>
                      <div className="row mb-4">
                        <div className="col-12 text-center">
                          <Button
                            className="btn-magenta pt-1 px-5"
                            onClick={this.onSkipReason.bind(
                              this,
                              currentAssignedToken.id
                            )}
                          >
                            Ok
                          </Button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </Modal>
            </>
          ) : (
            <div className="my-5 py-5">
              <h5 className="text-center">
                There are No Patients in the Queue!
              </h5>
            </div>
          )}
        </div>
      </div>
    );
  }
  showModal = () => {
    this.setState({
      visible: true,
    });
  };
  activateLoader() {
    this.setState({ isLoading: true });
  }
  deActivateLoader() {
    this.setState({ isLoading: false });
  }
  checkReBuildQ(queueitem, that) {
    confirm({
      title: "Do you Want to Re-build the Queue ?",
      content: "",
      onOk() {
        let queuelistid = queueitem.queuelistid || "";
        if (queuelistid !== undefined && queuelistid !== null) {
          // console.log("OK");
          let obj = {
            queueListId: queuelistid,
          };
          // console.log(obj);
          let Userlogobj = {
            user: JSON.parse(Storage.get("user")),
            action: "restore queue",
            date: new Date(),
            meta: obj,
          };
          userTrackService(Userlogobj);
          postService("restoreQueueById", "POST", { data: obj }).then((res) => {
            let Userlogobjres = {
              user: JSON.parse(Storage.get("user")),
              action: "restore queue - response",
              date: new Date(),
              meta: res,
            };
            userTrackService(Userlogobjres);
            if (res) {
              //that.refreshQueueListData();
              that.refreshSingleQueue(obj, "rebuild");
              this.getDoctorQueuePatients();
            }
          });
        }
      },
      onCancel() {
        // console.log("Cancel");
      },
    });
  }
  refreshSingleQueue(queueitem, action) {
    let queuelistid = queueitem.queuelistid || queueitem.queueListId;
    if (queuelistid !== undefined && queuelistid !== null) {
      let obj = {
        queueListId: queuelistid,
        action: action,
        "from":"doctorSide"
      };
      // this.activateLoader();
      postService("refreshQueueById", "POST", { data: obj }).then((res) => {
      
        // this.deActivateLoader();
        if (res) {
          let queueinfo = res.data || {};
        // socket.addEventListener('open', (event) => {
          // });
          
          // // Event listener for when a message is received from the server
          // socket.addEventListener('message', (event) => {
           // socket.onmessage = (event) => {
          //   const message = event.data;
          //   // Handle incoming messages from the server as needed
          // };
          this.state.parentthis.setState({ QRoomDetails: queueinfo, lastRefreshedAt: moment() });
          this.getDoctorQueuePatients();
          console.log("sattt")
        }
      });
    }
  }
  serviceCallForCheckIn(obj) {
    this.setState({ checkindelaymodalvisible: false });
    this.activateLoader();
    let Userlogobj = {
      user: JSON.parse(Storage.get("user")),
      action: "checkin",
      date: new Date(),
      meta: obj,
    };
    userTrackService(Userlogobj);
    postService("changePatientWorkflowStageTocheckIn", "POST", {
      data: obj,
    }).then((res) => {
      let Userlogobjres = {
        user: JSON.parse(Storage.get("user")),
        action: "checkin - response",
        date: new Date(),
        meta: res,
      };
      userTrackService(Userlogobjres);
      //if (res) {
      //  this.deActivateLoader();
      //this.props.refreshData();
      if (socket.readyState === WebSocket.OPEN) {
        console.log('WebSocket connection established Checkin Checkin.');
        // this.onStartQ(queueitem, "withoutassign")
        const jsonString = JSON.stringify({data:obj,action:"checkin"});
        socket.send(jsonString);
      };
     // this.refreshSingleQueue(obj, "checkin");
     // this.getDoctorQueuePatients();
      //}
    });
  }
  getDelayReasonsforDropdown() {
    postService("getCheckinDelayReasons", "GET", "").then((res) => {
      if (res.status) {
        this.setState({ checkinDelayReasonsforDropdown: res.data });
      }
    });
  }
  showCheckinDelayModal = (item) => {
    this.setState({
      checkindelaypatient: item,
      checkindelaymodalvisible: true,
      statecheckindelayReason: "",
      ModalError: false,
    });
  };
  changePatientStatustoCheckin(value, item) {
    // console.log('item',item)
    // console.log('QRoomDetails',this.state.QRoomDetails)
    // debugger;
    let currentObj = item;
    let currentQ = this.state.QRoomDetails || [];
    // let QueueList = this.props.singleQueueList || [];
    // QueueList = QueueList.filter((s) => s.display_status != "1");

    // QueueList.forEach((item1) => {
    //   if (item1.roomnumber === this.props.queueitem.roomnumber) {

    let checkWorkflowStageobj =
      currentQ.patients &&
      R.find(R.propEq("current_workflow_stage_id", "4"), currentQ.patients);
 let first_patient_id=currentQ.patients[0].id || '';

    let obj = {
      patientId: currentObj.id,
      queueListId: currentQ.queuelistid,
      doctor_id: currentQ.queue_doctor_id,
      delay_reason_id: this.state.statecheckindelayReason,
      delay_time: this.state.statecheckindelayTime,
      queue_delay: null,
    };
    if (!R.isNil(checkWorkflowStageobj)) {
      this.setState({
        ModalText: "You cannot Check-In two patients at a time.",
      });
      this.showModal();
    } else {
      let { appointment_date, service_time, id } = currentObj;
    
      if (
        appointment_date !== undefined &&
        appointment_date !== null &&
        appointment_date !== ""
      ) {
        let startDate = moment(new Date(appointment_date));
        let endDate = moment(new Date());
        startDate = moment(startDate);
        endDate = moment(endDate);
        let checkindelay = endDate.diff(startDate, "minutes", true);
        let checkindelayint = parseInt(checkindelay);
        if (checkindelayint > 0) {
          var cdt_time = new Date();
          var s = moment(cdt_time, "hh:mm A")
            .add(parseInt(service_time), "m")
            .format("hh:mm A");
          obj.queue_delay = s;
        }
        if (first_patient_id == id) {
          // console.log("direct 1st patient checkin..");
          this.serviceCallForCheckIn(obj);
        } else {
          // console.log("Reason for queue order deviation");
          this.setState({
            ModalText: "Reason for queue order deviation",
            statecheckindelayTime: checkindelayint,
          });
          this.showCheckinDelayModal(item);
        }
      } else {
        // console.log("No Appointment.");
        // this.serviceCallForCheckIn(obj);
        if (first_patient_id == id) {
          // console.log("direct 1st patient checkin..");
          this.serviceCallForCheckIn(obj);
        } else {
          // console.log("Reason for queue order deviation");
          this.setState({
            ModalText: "Reason for queue order deviation",
            statecheckindelayTime: null,
          });
          this.showCheckinDelayModal(item);
        }
      }
    }
    //   }
    // });
  }
  showTATModal = () => {
    this.setState({
      tatmodalvisible: true,
    });
  };
  TathandleOk = () => {
    this.setState({
      confirmLoading: false,
      tatmodalvisible: false,
    });
  };
  TAThandleCancel = () => {
    this.setState({
      tatmodalvisible: false,
    });
  };
  getTATReason(value) {
    this.setState({ TATexceededReason: value });
  }
  saveTATExceededReason = (item) => {
    let currentObj = item;
    let currentQ = this.state.QRoomDetails || [];
    // QueueList = QueueList.filter((s) => s.display_status != "1");
    // QueueList.forEach((item1) => {
    //   if (item1.roomnumber === this.props.queueitem.roomnumber) {
    let obj = {
      patientId: currentObj.id,
      queueListId: currentQ.queuelistid,
      TATexceededTime: this.state.TATexceededTime,
      TATexceededReason: this.state.TATexceededReason,
    };
    // console.log(obj);
    let Userlogobj = {
      user: JSON.parse(Storage.get("user")),
      action: "checkout with TAT reason",
      date: new Date(),
      meta: obj,
    };
    userTrackService(Userlogobj);
    this.activateLoader();
    postService("changePatientWorkflowStageTocheckOut", "POST", {
      data: obj,
    }).then((res) => {
      let Userlogobjres = {
        user: JSON.parse(Storage.get("user")),
        action: "checkout with TAT reason - response",
        date: new Date(),
        meta: res,
      };
      userTrackService(Userlogobjres);
      //if (res) {
      this.TAThandleCancel();
      //this.props.refreshData();
      if (socket.readyState === WebSocket.OPEN) {
        console.log('WebSocket connection established Checkin Checkin.');
        // this.onStartQ(queueitem, "withoutassign")
        const jsonString = JSON.stringify({data:obj,action:"checkout"});
        socket.send(jsonString);
      };
      //this.refreshSingleQueue(obj, "tatexceed");
      //}
    });
    //   }
    // });
  };
  onDoctorCheckout(patient) {
    this.setState({
      currentPatient: patient,
      ModalText: "Choose type of Check Out",
      checkoutModalVisible: true,
    });
  }
  onCheckoutModalSubmit() {
    if (this.state.checkoutReason) {
      this.setState({ checkoutModalVisible: false });
      this.changePatientStatustoCheckout("checkout");
    } else {
      this.setState({ ModalError: true });
    }
  }
  changePatientStatustoCheckout(value) {
    const { slug } = this.props.match.params;
    let currentObj = this.state.currentPatient;
    let currentQ = this.state.QRoomDetails || [];
    // let QueueList = this.props.singleQueueList || [];

    // QueueList = QueueList.filter((s) => s.display_status != "1");
    // QueueList.forEach((item1) => {
    //   if (item1.roomnumber === this.props.queueitem.roomnumber) {
      if(this.state.checkoutReason=="Review"){
            let obj = {
            patientId: currentObj.id,
            appointment_id:"",
            queueListId: currentQ.queuelistid,
            checkoutType:"Review",
            };
            let Userlogobj = {
              user: JSON.parse(Storage.get("user")),
              action: "checkout",
              date: new Date(),
              meta: obj,
            };
            userTrackService(Userlogobj);
            postService("changePatientWorkflowStageTocheckOut", "POST", {
              data: obj,
            }).then((res) => {
              let Userlogobjres = {
                user: JSON.parse(Storage.get("user")),
                action: "checkout - response",
                date: new Date(),
                meta: res,
              };
              userTrackService(Userlogobjres);
              //if (res) {
              //this.props.deActivateLoader();
              if (socket.readyState === WebSocket.OPEN) {
                console.log('WebSocket connection established Checkin Checkin.');
                // this.onStartQ(queueitem, "withoutassign")
                const jsonString = JSON.stringify({data:obj,action:"checkout"});
                socket.send(jsonString);
              };
              //this.props.refreshData();
               //this.props.refreshSingleQueue(obj, "checkout");
              //}
            });
        
       
  }
  else{ 



    //  else {
    //   let lastIndex = getCurrentPatientIdindex;
    //   if (currentQ.patients && currentQ.patients[lastIndex]) {
    //     lastPatientId = currentQ.patients[lastIndex].id;
    //     lastPatientId = lastPatientId.toString();
    //   }
    // }
    // console.log(
    //   `firstPatientId:${firstPatientId},abovePatientId:${abovePatientId},belowPatientId:${belowPatientId},lastPatientId:${lastPatientId},CurrentPatientIdindex:${getCurrentPatientIdindex}`
    // );
    let checkin_time = currentObj.checkin_time;
    if (checkin_time !== undefined && checkin_time !== null) {
      let startDate = moment(new Date(checkin_time)).format("LT");
      let endDate = moment(new Date()).format("LT");
      startDate = moment(startDate);
      endDate = moment(endDate);
      let TATEx = endDate.diff(startDate, "minutes", true);
      let serviceGroupTime = currentQ.service_time;
      // console.log(startDate, endDate);
      if (parseInt(TATEx) > parseInt(serviceGroupTime)) {
        // console.log("tat exceeded");
        this.setState({
          ModalText: "TAT Exceeded by " + TATEx + " min",
          TATexceededTime: TATEx,
        });
        this.showTATModal();
      } else {
        // console.log("tat not exceeded");
        let obj = {
          patientId: currentObj.id,
          queueListId: currentQ.queuelistid,
          checkoutType:"Normal",
        };
        // console.log(obj);
        this.activateLoader();
        let Userlogobj = {
          user: JSON.parse(Storage.get("user")),
          action: "checkout",
          date: new Date(),
          meta: obj,
        };
        // console.log("checkout", obj);
        // return false;
        userTrackService(Userlogobj);
        postService("changePatientWorkflowStageTocheckOut", "POST", {
          data: obj,
        }).then((res) => {
          this.setState({ checkoutReason: "" });
          let Userlogobjres = {
            user: JSON.parse(Storage.get("user")),
            action: "checkout - response",
            date: new Date(),
            meta: res,
          };
          userTrackService(Userlogobjres);
          //if (res) {
          //  this.props.deActivateLoader();
          this.deActivateLoader();
          //this.props.refreshData();
          if (socket.readyState === WebSocket.OPEN) {
            console.log('WebSocket connection established Checkin Checkin.');
            // this.onStartQ(queueitem, "withoutassign")
            const jsonString = JSON.stringify({data:obj,action:"checkout"});
            socket.send(jsonString);
          };
          //this.refreshSingleQueue(obj, "checkout");
          // this.getDoctorQueuePatients();

          //}
        });
      }
    }
    //   }
    // });
    
  }}
  selectRoom(room) {
    // console.log("selectRoom", room);
    this.setState({ selectedRoom: room });
  }
  doctorCurrPatientDetailsCol(list) {
    // console.log("doctorCurrPatientDetailsCol list", list);
    const { queueList, selectedRoom } = this.state;

    return (
      <div className="col-9 col-md-7 col-lg-9">
        {queueList && queueList.length > 1 && (
          <div
          // className="DoctorDetailsCard"
          // style={{
          //   height: "9.5%",
          //   width: "100%",
          //   margin: "0px 0px 1px",
          //   padding: "6px 10px 20px",
          // }}
          >
            {queueList.map((item, i) => (
              <Button
                className="mb-2 mx-2"
                style={{
                  backgroundColor: selectedRoom
                    ? item.roomnumber === selectedRoom.roomnumber && "#6c3964"
                    : queueList[0].roomnumber === item.roomnumber && "#6c3964",
                  color: selectedRoom
                    ? item.roomnumber === selectedRoom.roomnumber
                      ? "#ffffff"
                      : "#6c3964"
                    : queueList[0].roomnumber === item.roomnumber
                    ? "#ffffff"
                    : "#6c3964",
                  borderColor: "#6c3964",
                }}
                // type={
                //   selectedRoom
                //     ? item.roomnumber === selectedRoom.roomnumber && "primary"
                //     : queueList[0].roomnumber === item.roomnumber && "primary"
                // }
                id={i}
                onClick={this.selectRoom.bind(this, item)}
              >
                {item.roomnumber}
              </Button>
            ))}
          </div>
        )}
        <div
          className={`card b-card ${
            queueList && queueList.length < 2 ? "b-card1" : "b-card2"
          } px-4 py-2`}
        >
          {list.length ? (
            <>
              <span className="row Current-Patient-title">
                Current Patient Details
              </span>
              <div className="row my-4">
                <div className="col-5">
                  <div className="PatientDetails">
                    <div className="row pl-3">
                      <div class="patientNameIcon">
                        <img
                          src={user}
                          alt=""
                          className="patientNameIconImage"
                        />
                      </div>
                      <span class="ml-3 patientNamedetails">
                        <span class="row text-style-1">Name</span>
                        <span className="row">
                          {list && list[0] && list[0]["name"]}
                        </span>
                      </span>
                    </div>
                    <div className="row pl-3 py-2">
                      <div class="patientGenderIcon">
                        <img
                          src={gender}
                          alt=""
                          className="patientGenderIconImage"
                        />
                      </div>
                      <span class="patientGender">
                        Gender
                        <span class="row pl-3 text-style-1">--</span>
                      </span>
                    </div>
                    <div className="row pl-3">
                      <div class="patientageIcon">
                        <img
                          src={calender}
                          alt=""
                          className="patientageIconImage"
                        />
                      </div>
                      <span class="patientAge">
                        <span class="row pl-3 text-style-1">Age</span>
                        {/* 27 Yrs, 3 Months, 20 Days */} --
                      </span>
                    </div>
                  </div>
                </div>
                <div className="col-3 mx-2">
                  <div className="row DNuidcard">
                    <img src={Patient} alt="" class="PatientIcon" />
                    <div class="LineCopy">
                      <span class="row UID-no">
                        <span class="text-style-1">Phone</span>
                      </span>
                      <span class="row UID-no">
                        {list && list[0] && list[0]["phonenumber"]}
                      </span>
                    </div>
                  </div>
                  <div className="row DNtokenCard">
                    <img src={token} alt="" class="tokenCardIcon" />
                    <div class="LineCopy">
                      <span class="row Token-No">
                        Appt Time
                        {/* <span class="text-style-1">12:30PM</span> */}
                        <span class="text-style-1">
                          {" "}
                          {list &&
                            list[0] &&
                            list[0]["appointment_date"] &&
                            this.renderTime(list[0]["appointment_date"])}
                        </span>
                      </span>
                    </div>
                  </div>
                  <div className="row DNserviceCard">
                    <img src={service} alt="" class="serviceCardimg" />
                    <div class="LineCopy">
                      <span class="row Service-Name-Billing">Speciality</span>
                      <span class="row Service-Name-Billing">
                        <span class="text-style-1">
                          {this.state.QRoomDetails &&
                            this.state.QRoomDetails["specialization_code"]}
                        </span>
                      </span>
                    </div>
                  </div>
                </div>
                <div className="col-3 ml-4">
                  <div className="row DNuidcard">
                    <img src={userColor} alt="" class="uidcardIcon" />
                    <div class="LineCopy">
                      <span class="row UID-no">
                        <span class="text-style-1 mb-0">UID</span>
                      </span>
                      <span class="row UID-no">
                        {list && list[0] && list[0]["umr"]}
                      </span>
                    </div>
                  </div>
                  <div className="row DNtokenCard">
                    <img src={token} alt="" class="tokenCardIcon" />
                    <div class="LineCopy">
                      <span class="row UID-no">
                        <span class="text-style-1 mb-0"> Service Name</span>
                      </span>
                      <span class="row UID-no">
                        {list && list[0] && list[0]["bill_service_group"]}
                      </span>
                    </div>
                  </div>
                  <div className="row DNserviceCard">
                    <img src={service} alt="" class="serviceCardimg" />
                    <div class="LineCopy">
                      <span class="row Service-Name-Billing">
                        Consultation Mode
                      </span>
                      <span class="row Service-Name-Billing">
                        <span class="text-style-1">Online</span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <Button
                  className="Chekoutandnext text-center"
                  // onClick={this.changePatientStatustoCheckout.bind(
                  //   this,
                  //   "checkout",
                  //   list[0]
                  // )}
                  onClick={this.onDoctorCheckout.bind(this, list[0])}
                  disabled={list[0].status && list[0].status === "3"}
                >
                  <span>CheckOut</span>
                </Button>
                <Button
                  className="Skipandnext text-center"
                  onClick={this.skipPatientFromQueue.bind(
                    this,
                    list && list[0]
                  )}
                  // onClick={this.serviceCallForSkip.bind(this, list[0])}
                  // disabled={(list.length === 1) ? true : false}
                >
                  <span>Skip</span>
                </Button>
              </div>
              <Modal
                centered
                footer={null}
                maskClosable={false}
                visible={this.state.modalVisible}
                onOk={() => this.setModalVisible(false)}
                onCancel={() => this.setModalVisible(false)}
              >
                <div className="row">
                  <button
                    type="button"
                    class="btn"
                    onClick={() => this.setModalVisible(false)}
                  >
                    {/* <Icon type="close" className="popup-close" /> */}
                    

<CloseOutlined className="popup-close" />

                  </button>
                  <div className="col-12 position-relative form-block py-4">
                    <form noValidate>
                      <div className="row mb-4">
                        <div className="col-12 mx-auto">
                          <h2 className="text-center">Choose reason to skip</h2>
                        </div>
                      </div>
                      <div className="row mb-5">
                        <div className="col-8 w-100 mx-auto">
                          <Select
                            placeholder="Select the reason"
                            onChange={this.selectReason.bind(this)}
                          >
                            <Option value="">Select the Reason</Option>
                            {this.state.skipReasonsforDropdown &&
                              this.state.skipReasonsforDropdown.map((d, i) => {
                                return (
                                  <Option value={d.id} key={i}>
                                    {d.reason}
                                  </Option>
                                );
                              })}
                          </Select>
                        </div>
                      </div>
                      <div className="row mb-4">
                        <div className="col-12 text-center">
                          <Button
                            className="btn-magenta pt-1 px-5"
                            onClick={this.onSkipReason.bind(this)}
                          >
                            Ok
                          </Button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </Modal>
            </>
          ) : (
            <div className="my-5 py-5">
              <h5 className="text-center">
                Patients are not yet arrived. Please contact the OPD Operator
                {/* {this.state.getDoctorQueuePatientsMessage} */}
              </h5>
            </div>
          )}
        </div>
      </div>
    );
  }
  renderBody() {
    const { slug } = this.props.match.params;
    let {
      startBilling,
      ifLoading,
      searchVal,
      filteredTokenListOnSearch,
      tokensList,
      doctorViewPatientsList,
      billingPatients,
      selectedRoom,
    } = this.state;
    let billerPatientlist = searchVal ? filteredTokenListOnSearch : tokensList;
    // let displayPatients = billingPatients
    //   ? billingPatients
    //   : doctorViewPatientsList;
    // let displayPatients = billingPatients
    //   ? billingPatients
    //   : selectedRoom
    //   ? selectedRoom.patients
    //   : doctorViewPatientsList;
    let displayPatients = billingPatients.length
      ? billingPatients
      : doctorViewPatientsList;

    if (slug === "biller-view") {
      return (
        <>
          {startBilling ? (
            <>
              {ifLoading && <CustomLoader />}
              {this.queueCol(billerPatientlist)}
              {this.billerCurrPatientDetailsCol(billerPatientlist)}
            </>
          ) : (
            this.billerWelcomeScreen()
          )}
        </>
      );
    }

    if (slug === "doctor-view") {
      return (
        // <>
        //   {startBilling ? (
        <>
          {/* {console.log("selectedRoom", selectedRoom)} */}
          {ifLoading && <CustomLoader />}
          {displayPatients && this.queueCol(displayPatients)}
          {displayPatients && this.doctorCurrPatientDetailsCol(displayPatients)}
        </>
        //   ) : (
        //     this.billerWelcomeScreen()
        //   )}
        // </>
      );
    }
  }
  render() {
    const {
      workstationsList,
      workstationSelected,
      workstationSelectedDetails,
      roomsList,
      roomSelected,
      QRoomDetails,
      skipmodalvisible,
      stateskipReason,
      checkoutModalVisible,
      checkoutReason,
      confirmLoading,
      ModalText,
      ModalError,
      currentObj,
      visible,
      tatmodalvisible,
      checkindelaymodalvisible,
      statecheckindelayReason,
    } = this.state;
    let item = currentObj && currentObj;
    return (
      <div className="row q-p-details -Token-Generator">
          <IdleTimer
          ref={ref => { this.idleTimer = ref }}
          onIdle={this.onIdle}
          onAction={this.onAction}
          debounce={250}
          timeout={1000 * 60} 
        />  
        
        {this.renderBody()}
        {this.state.ifLoading && (
          <div className="loader">
            <Spin indicator={antIcon} tip="Loading..." />
          </div>
        )}
        <Modal
          visible={skipmodalvisible}
          onOk={this.skiphandleOk}
          confirmLoading={confirmLoading}
          onCancel={this.skiphandleCancel}
          footer={null}
        >
          <p>{ModalText}</p>
          <div className="col-12 mb-3">
            {ModalError ? (
              <small className="text-danger">Please select the reason.</small>
            ) : (
              ""
            )}
            <Select
              value={stateskipReason}
              style={{ width: "100%" }}
              onChange={this.getSkipReason.bind(this)}
            >
              <Option value="">Select the Reason</Option>
              {this.state.skipReasonsforDropdown &&
                this.state.skipReasonsforDropdown.map((d, i) => {
                  return (
                    <Option value={d.id} key={i}>
                      {d.reason}
                    </Option>
                  );
                })}
            </Select>
          </div>
          <Button
            type="primary"
            onClick={this.serviceCallForSkip.bind(this, item)}
          >
            Submit
          </Button>
        </Modal>
        <Modal
          visible={checkoutModalVisible}
          onOk={this.checkoutHandleOk}
          confirmLoading={confirmLoading}
          onCancel={this.checkoutHandleCancel}
          footer={null}
        >
          <p>{ModalText}</p>
          <div className="col-12 mb-3">
            {ModalError ? (
              <small className="text-danger">Please select the Type.</small>
            ) : (
              ""
            )}
            <Select
              value={checkoutReason}
              style={{ width: "100%" }}
              onChange={this.getCheckoutReason.bind(this)}
            >
              <Option value="">Select type of checkout</Option>
                    <Option value="Review">Review Check Out</Option>
                    <Option value="Normal">Normal Check Out</Option>
            </Select>
          </div>
          <Button
            type="primary"
            onClick={this.onCheckoutModalSubmit.bind(this)}
          >
            Submit
          </Button>
        </Modal>
        <Modal
          visible={visible}
          confirmLoading={confirmLoading}
          onCancel={this.handleCancel}
          footer={[
            <Button key="submit" type="primary" onClick={this.handleCancel}>
              OK
            </Button>,
          ]}
        >
          <p>{ModalText}</p>
        </Modal>
        <Modal
          visible={tatmodalvisible}
          onOk={this.TathandleOk}
          confirmLoading={confirmLoading}
          onCancel={this.TAThandleCancel}
          footer={null}
        >
          <p>{ModalText}</p>
          <div className="col-12 mb-3">
            <Select
              defaultValue={this.state.TATexceededReason}
              style={{ width: "100%" }}
              onChange={this.getTATReason.bind(this)}
            >
              <Option value="Reason1">Reason 1</Option>
              <Option value="Reason2">Reason 2</Option>
              <Option value="Reason3">Reason 3</Option>
              <Option value="Reason4">Reason 4</Option>
            </Select>
          </div>
          <Button
            type="primary"
            onClick={this.saveTATExceededReason.bind(this, item)}
          >
            Submit
          </Button>
        </Modal>
        <Modal
          visible={checkindelaymodalvisible}
          onOk={this.delayhandleOk}
          confirmLoading={confirmLoading}
          onCancel={this.delayhandleCancel}
          footer={null}
        >
          <p>{ModalText}</p>
          <div className="col-12 mb-3">
            {ModalError ? (
              <small className="text-danger">Please select the reason.</small>
            ) : (
              ""
            )}
            <Select
              value={statecheckindelayReason}
              style={{ width: "100%" }}
              onChange={this.getDelayReason.bind(this)}
            >
              <Option value="">Select the Reason</Option>
              {this.state.checkinDelayReasonsforDropdown &&
                this.state.checkinDelayReasonsforDropdown.map((d, i) => {
                  return (
                    <Option value={d.id} key={i}>
                      {d.reason}
                    </Option>
                  );
                })}
            </Select>
          </div>
          <Button type="primary" onClick={this.checkinCallWithDelay.bind(this)}>
            Submit
          </Button>
        </Modal>
      </div>
    );
  }
}
export default Biller;
